import "./style.scss";
import Bankers from "../OrgMapper";
import Robo from "../../icons/robo.svg?react";
import { getorguser, getorgApplication } from "../../api/common";
interface Props {
  banks: any[];
  updateAuditeeInfo: any;
  showAICompanion: boolean;
  setShowAICompanion?: React.Dispatch<React.SetStateAction<boolean>>;
}

const step1AuditeeOrganization: React.FC<Props> = ({
  banks,
  updateAuditeeInfo,
  showAICompanion,
  setShowAICompanion,
}) => {
  const handleFetchOrgDetails = async (orgId: number) => {
    const [users, apps] = await Promise.all([
      getorguser(orgId),
      getorgApplication(orgId),
    ]);

    const formattedApps = (apps || []).map((item: any) => ({
      applicationId: item.applicationId ?? item.id,
      applicationName: item.applicationName ?? item.name,
    }));

    return { users, applications: formattedApps };
  };

  return (
    <div className="form-row-1 marginstep1">
      <div className="align-AI">
        {!showAICompanion && (
          <div
            className="outer-circle"
            data-testid="robo-icon"
            onClick={() => setShowAICompanion?.(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setShowAICompanion?.(true);
              }
            }}
          >
            <Robo className="ai-bot-button" />
          </div>
        )}
      </div>
      <Bankers
        banks={banks}
        fetchOrgDetails={handleFetchOrgDetails}
        onMappingChange={(updated: any) => {
          updateAuditeeInfo("organizations", updated);
        }}
        showAICompanion={showAICompanion}
      />
    </div>
  );
};

export default step1AuditeeOrganization;
